function readyCurrentForm(step) {
  jQuery(`#next-btn-loader-step-${step}`).show()
  jQuery(`#next-btn-content-step-${step}`).hide()

  let formUuid = localStorage.getItem("form-uuid")
  if (!formUuid) {
    formUuid = jQuery("#form-step-container").data("uuid")
    localStorage.setItem("form-uuid", formUuid)
  }

  const formElement = document.getElementById(`form-step-${step}`)
  const formData = new FormData(formElement)
  const data = Object.fromEntries(formData)
  data.uuid = formUuid
  data.ip = getFromStorage("ip")

  if (step == 1) {
    checkFirstStep(data)
  } else if (step == 5) {
    lastStepSendData(data)
  } else {
    showNextForm(step + 1, data)
  }
}

function checkFirstStep(data) {
  setTimeout(() => {
    checkSecurity(data)
  }, 50)
}

function lastStepSendData(data) {
  setTimeout(() => {
    showLoadingScreen(true)
    sendLead(data)
  }, 50)
}

function showNextForm(step, data) {
  setTimeout(() => {
    setMultiformData(step, data, "next")
  }, 50)
}

function showPreviousForm(step, from = "previous") {
  if (from !== "sidebar") {
    jQuery(`#prev-btn-loader-step-${step + 1}`).show()
    jQuery(`#prev-btn-content-step-${step + 1}`).hide()
  }

  if (from == "sidebar") {
    jQuery("#sidebar-menu").addClass("loading")
  }

  setTimeout(() => {
    setMultiformData(step, null, from)
  }, 200)
}

function submitForm(step) {
  var validatedForm = validateForm(step)
  if (!validatedForm) {
    return
  }

  if( isRecaptchaV3Active() && step == 1 ) {
    recaptchaV3Validation().then(function () {
      readyCurrentForm(step);
    }).catch(function (error) {
      console.error("Error during reCAPTCHA validation:", error);
    });
  } else {
    readyCurrentForm(step)
  }
}

function prefillGenderField(value) {
  if (!value || value == "") {
    return
  }
  const button = jQuery(`#LeadForm-gender label.btn.${value}`)
  button.addClass("active")

  jQuery("#form-toggle-gender").val(value)
  return
}

function prefillPhonePlanField(value) {
  if (!value || value == "") {
    return
  }
  const button = jQuery(`#LeadForm-phone_plan label.btn.${value}`)
  button.addClass("active")

  jQuery("#form-toggle-phone_plan").val(value)
  return
}

function prefillCarOwnerField(value) {
  jQuery(".field-LeadForm-car_plate_number").hide()
  if (!value || value == "") {
    return
  }

  if( value == "YES" ) {
    jQuery(".field-LeadForm-car_plate_number").show()
  }
  const button = jQuery(`#LeadForm-car_owner label.btn.${value}`)
  button.addClass("active")

  jQuery("#LeadForm-car_owner").val(value)
  return
}
function prefillDateFields(field, value) {
  console.log(`prefillDateFields called with field: "${field}", value: "${value}"`);
  if (!value || value === "" || typeof value !== 'string' || !value.includes('-')) {
    console.warn(`prefillDateFields: Invalid value for field "${field}": ${value}. Expected "DD-MM-YYYY".`);
    return;
  }

  const parts = value.split("-");
  if (parts.length === 3) {
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    // IDs are global, so document.querySelector is fine here.
    const dayEl = document.querySelector(`#${field}-day`);
    const monthEl = document.querySelector(`#${field}-month`);
    const yearEl = document.querySelector(`#${field}-year`);

    console.log(`For field "${field}", attempting to set Day: ${day}, Month: ${month}, Year: ${year}`);
    console.log(`Elements found - Day:`, dayEl, `Month:`, monthEl, `Year:`, yearEl);

    if (dayEl) dayEl.value = day;
    else console.warn(`Day select element "#${field}-day" not found.`);
    
    if (monthEl) monthEl.value = month;
    else console.warn(`Month select element "#${field}-month" not found.`);

    if (yearEl) yearEl.value = year;
    else console.warn(`Year select element "#${field}-year" not found.`);

  } else {
    console.warn(`Date value for field "${field}" is not in expected DD-MM-YYYY format: ${value}`);
  }
}

function prefillForm(step = 1) {
  let dataToPrefill = null;
  const lsKey = `form-step-data-${step}`;
  const storedDataFromLocalStorage = localStorage.getItem(lsKey);

  console.log(`Attempting to prefill step ${step}. Key: ${lsKey}`); // Log attempt

  if (storedDataFromLocalStorage) {
    try {
      dataToPrefill = JSON.parse(storedDataFromLocalStorage);
      console.log(`Successfully parsed data for step ${step} from localStorage:`, dataToPrefill);
    } catch (e) {
      console.error("Error parsing localStorage data for step " + step, e);
      localStorage.removeItem(lsKey);
      dataToPrefill = null; // Ensure it's null if parsing failed
    }
  } else {
    console.log(`No data found in localStorage for key ${lsKey}.`);
  }

  if (!dataToPrefill) {
    const storedDataFromCookie = getFromCookie(`form-step-${step}`);
    if (storedDataFromCookie) {
      try {
        var decode = decodeURIComponent(storedDataFromCookie);
        dataToPrefill = JSON.parse(decode);
        console.log(`Prefilling step ${step} from cookie data:`, dataToPrefill);
      } catch (e) {
        console.error("Error parsing cookie data for step " + step, e);
        dataToPrefill = null; // Ensure it's null if parsing failed
      }
    } else {
      console.log(`No data found in cookies for form-step-${step}.`);
    }
  }

  if (dataToPrefill) {
    const formData = dataToPrefill;
    const formElement = document.getElementById(`form-step-${step}`);

    if (!formElement) {
        console.error(`Form element for step ${step} (ID: form-step-${step}) not found.`);
        return;
    }
    console.log(`Form element for step ${step} found:`, formElement);

    for (var key in formData) {
      if (!formData.hasOwnProperty(key)) continue;

      // Skip meta fields but handle g-recaptcha-response
      if (key === "uuid" || key === "ip" || key === "recaptcha-token-v3") {
        continue;
      }
      if (key === "g-recaptcha-response" && formData[key]) {
         localStorage.setItem("recaptcha-response", formData[key]);
         continue; // Continue after handling this meta field
      }


      const value = formData[key];
      console.log(`Processing key: "${key}", value: "${value}" for step ${step}`);

      var el = formElement.querySelector(`[name="${key}"]`);

      if (el) {
        // console.log(`Element found for name "${key}":`, el);
        const fieldNameMatch = key.match(/LeadForm\[([^)]+)\]/);
        const fieldName = fieldNameMatch ? fieldNameMatch[1] : null;

        if (fieldName === "gender") {
          prefillGenderField(value);
          let genderRadio = formElement.querySelector(`input[name="LeadForm[gender]"][value="${value}"]`);
          if (genderRadio) {
            genderRadio.checked = true;
            // console.log(`Checked gender radio for value: ${value}`);
          } else {
            console.warn(`Gender radio not found for name="LeadForm[gender]", value="${value}" in step ${step}`);
          }
          continue;
        }
        if (fieldName === "phone_plan") {
          prefillPhonePlanField(value);
          let phonePlanRadio = formElement.querySelector(`input[name="LeadForm[phone_plan]"][value="${value}"]`);
          if (phonePlanRadio) {
            phonePlanRadio.checked = true;
            // console.log(`Checked phone_plan radio for value: ${value}`);
          } else {
            console.warn(`Phone plan radio not found for name="LeadForm[phone_plan]", value="${value}" in step ${step}`);
          }
          continue;
        }
        if (fieldName === "car_owner") {
          prefillCarOwnerField(value); // Handles visibility
          let carOwnerRadio = formElement.querySelector(`input[name="LeadForm[car_owner]"][value="${value}"]`);
          if (carOwnerRadio) {
            carOwnerRadio.checked = true;
            // console.log(`Checked car_owner radio for value: ${value}`);
          } else {
            console.warn(`Car owner radio not found for name="LeadForm[car_owner]", value="${value}" in step ${step}`);
          }
          // No continue, allow general logic for car_plate_number if present
        }

        const dateFields = ["birth_date", "remuneration_deadline", "employment_start_date"];
        if (dateFields.includes(fieldName) && value && typeof value === 'string' && value.includes('-')) {
            console.log(`Calling prefillDateFields for field: ${fieldName}, value: ${value}`);
            prefillDateFields(fieldName, value);
            continue;
        }
        
        if (fieldName === "bad_credit_history") {
            el.checked = value === '1' || value === true || value === 'true' || value === 'on';
            // console.log(`Set bad_credit_history checkbox to: ${el.checked}`);
            continue;
        }

        if (el.type === 'checkbox') {
          el.checked = value === '1' || value === true || value === 'true' || value === 'on';
          // console.log(`Set checkbox "${key}" to: ${el.checked}`);
        } else if (el.type === 'radio') {
          const radioGroup = formElement.querySelectorAll(`[name="${key}"]`);
          let foundRadioInGroup = false;
          radioGroup.forEach(radio => {
            radio.checked = (radio.value === value);
            if (radio.checked) foundRadioInGroup = true;
          });
          // if (foundRadioInGroup) console.log(`Set radio group "${key}" to value: ${value}`);
          // else console.warn(`Value "${value}" not found in radio group "${key}"`);
        } else if (el.tagName === 'SELECT') {
          el.value = value;
          // console.log(`Set select "${key}" to value: ${value}`);
        } else { 
          el.value = value;
          // console.log(`Set input/textarea "${key}" to value: ${value}`);
        }
      } else {
        console.warn(`Element with name "${key}" NOT FOUND in step ${step}. Form element was:`, formElement);
      }
    }

    const occupationValue = formData['LeadForm[occupation]'];
    if (occupationValue) {
        const employmentStartDateFieldContainer = formElement.querySelector(".field-LeadForm-employment_start_date");
        const jobAreaFieldContainer = formElement.querySelector(".field-LeadForm-job_area");

        if (employmentStartDateFieldContainer) {
            const displayStyle = (occupationValue === "EMPLOYED_INDEFINITE_PERIOD") ? "" : "none";
            employmentStartDateFieldContainer.style.display = displayStyle;
            // console.log(`Set display of .field-LeadForm-employment_start_date to: ${displayStyle}`);
        }
        if (jobAreaFieldContainer) {
             const displayStyle = (["EMPLOYED_INDEFINITE_PERIOD", "ECONOMIC_ACTIVITY", "MATERNITY_LEAVE", "PENSIONER1"].includes(occupationValue)) ? "" : "none";
            jobAreaFieldContainer.style.display = displayStyle;
            // console.log(`Set display of .field-LeadForm-job_area to: ${displayStyle}`);
        }
    }
  } else {
    console.log(`No data (dataToPrefill is null/empty) to prefill step ${step}.`);
  }
}

function getFromStorage(name) {
  const item = window.localStorage.getItem(name)
  if (item === "undefined") {
    if (name === "transaction_id") {
      return 0
    }
    return "n/a"
  }

  return item
}

function getFromCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts.length === 2) {
    return parts.pop().split(";").shift()
  }
}

function scrollToErrorElement() {
  var top = jQuery(".has-error").offset().top
  var height = jQuery("header.header").height()
  var el = jQuery([document.documentElement, document.body])
  el.animate({ scrollTop: top - height - 5 }, 2000)
}


jQuery('#previous-button-step-2').on('click', function () {
  jQuery('.steps span').removeClass('active');
  jQuery('.steps span:nth-child(2)').addClass('active');
});

jQuery('#previous-button-step-3').on('click', function () {
  jQuery('.steps span').removeClass('active');
  jQuery('.steps span:nth-child(3)').addClass('active');
});

jQuery('#previous-button-step-4').on('click', function () {
  jQuery('.steps span').removeClass('active');
  jQuery('.steps span:nth-child(4)').addClass('active');
});

jQuery('#previous-button-step-5').on('click', function () {
  jQuery('.steps span').removeClass('active');
  jQuery('.steps span:nth-child(5)').addClass('active');
});

jQuery('#previous-button-step-6').on('click', function () {
  jQuery('.steps span').removeClass('active');
  jQuery('.steps span:nth-child(6)').addClass('active');
});